module.exports = __webpack_public_path__ + "img/f4-02.4b01aece.png";